export default __webpack_public_path__ + "static/media/temp.fb67d411.svg";